<template>
  <div className="search-content">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'SihaoLayout',
  data() {
    return {
      tabs: {
        items: [
          {
            key: '1',
            title: '四好运动员申报'
          },
          {
            key: '2',
            title: '运动员人员管理'
          },
        ],
        active: () => {
          switch (this.$route.path) {
            case '/csihao/SihaoList':
              return '1'
            case '/csihao/SihaomemberList':
              return '2'
            case '/dakejian/KaoguanList':
              return '3'
            default:
              return '1'
          }
        },
        callback: (key) => {
          switch (key) {
            case '1':
              this.$router.push('/csihao/SihaoList')
              break
            case '2':
              this.$router.push('/csihao/SihaomemberList')
              break
            case '3':
              this.$router.push('/club/KaoguanList')
              break
            default:
              this.$router.push('/workplace')
          }
        }
      },
      search: false
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
.search-head {
  background-color: #fff;
  margin: -25px -24px -24px;

  .search-input {
    text-align: center;
    margin-bottom: 16px;
  }
}

.search-content {
  margin-top: 0px;
}
</style>
